export const MODULOS_TAGS = {
  PLATAFORMACLIENTE: 'plataforma_cliente',
  PLATAFORMA_CRM: 'plataforma_crm',
  PLATAFORMA_FORMALIZACAO: 'plataforma_formalizacao',
  PLATAFORMA_RELACIONAMENTOS: 'plataforma_relacionamento'
};
